/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageTopLandingsDto } from '../../models/usage-top-landings-dto';

export interface GetUsageTopLandings$Params {
  from?: string;
  to?: string;
  take?: number;
  'X-API-Version'?: string;
}

export function getUsageTopLandings(http: HttpClient, rootUrl: string, params?: GetUsageTopLandings$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageTopLandingsDto>> {
  const rb = new RequestBuilder(rootUrl, getUsageTopLandings.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('take', params.take, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageTopLandingsDto>;
    })
  );
}

getUsageTopLandings.PATH = '/api/usage-statistics/landings';
